module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/io-c32d7f9e59460fb90af6fdf4c757a860.svg";